/**
 * Capitalize the first letter of a string. Can be used for example to capitalize a value that's returned fully capitalized
 * @param string
 * @returns string with the first letter capitalized
 * @example capitalizeFirstLetter('MONTHLY') // returns 'Monthly'
 */
export const capitalizeFirstLetter = (string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
